import React from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import {useService} from "../hooks/useService";
import SessionStorage from "../../services/SessionStorage";

export default function PrivateRoute({ component: Component, ...rest }) {
  /**
   * @type {SessionStorage}
   */
  const storage = useService(SessionStorage);
  const { accessToken } = storage.getSession();
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!accessToken) {
          return <Redirect to="/auth/logout" />;
        }
        return <Component {...props} />;
      }}
    />
  );
}

PrivateRoute.propTypes = {
  component: PropTypes.func,
};
